import { render, staticRenderFns } from "./ring-add.vue?vue&type=template&id=10e5972c&scoped=true"
import script from "./ring-add.vue?vue&type=script&lang=js"
export * from "./ring-add.vue?vue&type=script&lang=js"
import style0 from "./ring-add.vue?vue&type=style&index=0&id=10e5972c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5972c",
  null
  
)

export default component.exports